import { render } from "./ImageryInspectorView.vue?vue&type=template&id=b7b5c6f2"
import script from "./ImageryInspectorView.vue?vue&type=script&lang=js"
export * from "./ImageryInspectorView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__